import React from "react";
import { Eye, Pencil, Trash2, Package, BellOff, ClipboardList } from "lucide-react";
import LegalLayout from "@/components/LegalLayout/LegalLayout";
import { CONTACTS } from "@/constants/contacts";

const RIGHTS = [
  {
    icon: <Eye size={18} />,
    title: "Ver seus dados",
    body: "solicite uma cópia de tudo que temos sobre você",
  },
  {
    icon: <Pencil size={18} />,
    title: "Corrigir seus dados",
    body: "atualize informações incorretas ou desatualizadas",
  },
  {
    icon: <Trash2 size={18} />,
    title: "Excluir seus dados",
    body: "solicite a exclusão da sua conta e dados associados",
  },
  {
    icon: <Package size={18} />,
    title: "Exportar seus dados",
    body: "receba seus prontuários em formato PDF ou JSON",
  },
  {
    icon: <BellOff size={18} />,
    title: "Revogar consentimento",
    body: "retire autorização de tratamentos baseados em consentimento",
  },
  {
    icon: <ClipboardList size={18} />,
    title: "Saber com quem compartilhamos",
    body: "lista completa de fornecedores que processam seus dados",
  },
];

export default function LGPDPage() {
  return (
    <LegalLayout title="Seus dados são seus." testId="lgpd-page">
      <p className="legal-intro">
        O Akali AI coleta apenas o necessário para entregar o serviço. Seus
        dados ficam armazenados no Brasil, nunca são vendidos a terceiros, e
        você pode pedir para ver, corrigir ou apagar tudo a qualquer momento.
        Esta página explica isso em linguagem simples — sem juridiquês.
      </p>

      <div className="legal-section">
        <h2>O que coletamos e por quê</h2>

        <div className="lgpd-cards">
          <div className="glass lgpd-card" data-testid="lgpd-card-cadastro">
            <h3 className="lgpd-card-title">Seus dados de cadastro</h3>
            <p className="lgpd-card-body">
              Nome, e-mail, CREFITO.
            </p>
            <p className="lgpd-card-body">
              <strong style={{ color: "var(--color-text-primary)" }}>Por quê:</strong>{" "}
              para criar sua conta.
            </p>
          </div>

          <div className="glass lgpd-card" data-testid="lgpd-card-uso">
            <h3 className="lgpd-card-title">Seus dados de uso</h3>
            <p className="lgpd-card-body">
              Como você usa o sistema.
            </p>
            <p className="lgpd-card-body">
              <strong style={{ color: "var(--color-text-primary)" }}>Por quê:</strong>{" "}
              para melhorar o produto.
            </p>
          </div>

          <div className="glass lgpd-card" data-testid="lgpd-card-prontuarios">
            <h3 className="lgpd-card-title">Os prontuários que você gera</h3>
            <p className="lgpd-card-body">
              Transcrições e documentos.
            </p>
            <p className="lgpd-card-body">
              <strong style={{ color: "var(--color-text-primary)" }}>Por quê:</strong>{" "}
              para entregar o serviço. Nunca usados para treinar IA sem sua
              autorização.
            </p>
          </div>
        </div>
      </div>

      <div className="legal-section">
        <h2>Seus direitos</h2>

        <div className="lgpd-rights">
          {RIGHTS.map((r, i) => (
            <div className="lgpd-right" key={r.title} data-testid={`lgpd-right-${i}`}>
              <div className="lgpd-right-icon">{r.icon}</div>
              <div>
                <p className="lgpd-right-title">{r.title}</p>
                <p className="lgpd-right-body">{r.body}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="legal-section">
        <h2>Como exercer seus direitos</h2>
        <ol>
          <li>
            Envie e-mail para{" "}
            <a href={`mailto:${CONTACTS.privacy}`} className="legal-mail">
              {CONTACTS.privacy}
            </a>
            .
          </li>
          <li>Identifique-se como titular (nome + e-mail cadastrado).</li>
          <li>Descreva o direito que deseja exercer.</li>
          <li>
            <strong>Prazo de resposta:</strong> até 15 dias úteis.
          </li>
        </ol>
      </div>

      <div className="legal-section">
        <h2>Dúvidas ou reclamações</h2>
        <p>
          Se não ficar satisfeito com nossa resposta, você pode procurar a
          Autoridade Nacional de Proteção de Dados (ANPD) em{" "}
          <a
            href="https://gov.br/anpd"
            target="_blank"
            rel="noopener noreferrer"
            className="legal-mail"
          >
            gov.br/anpd
          </a>
          .
        </p>
      </div>
    </LegalLayout>
  );
}
